import { FC, useMemo } from 'react';

import lodash from 'lodash';
import { ThemeProvider } from 'styled-components';

import { GlobalStyle } from './styles';
import { theme } from '../../constants/theme';
import { ThemeContext } from '../../hooks/useTheme';
import { ITheme } from '../../models/ITheme';

const lightTheme: ITheme = {
  name: 'light',
  ...theme,
};

const StyledComponentsThemeProvider: FC<{
  customTheme?: DeepPartial<ITheme>;
}> = ({ customTheme = {}, children }) => {
  const theme = useMemo(
    () => lodash.merge(lightTheme, customTheme),
    [customTheme],
  );

  return (
    <ThemeContext.Provider value={{ theme }}>
      <ThemeProvider theme={theme}>
        {children}

        <GlobalStyle />
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default StyledComponentsThemeProvider;
